/* eslint-disable */
import React from 'react';
import { matchPath, NavLink as RouterLink, useLocation } from 'react-router-dom';
import { alpha, styled } from '@mui/material/styles';
import { Box, Divider, List, ListItemButton, ListItemText, MenuItem, Tooltip } from '@mui/material';
import { useTranslation } from "react-i18next";
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import {useSelector} from "react-redux";
import {selectIsRegisterCompleted} from "@/store/slices/authSlice";


const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    'root': {

        '&:hover': {
            boxShadow: 'none',
        },
    },
    '& .MuiPaper-root': {
        backgroundColor: 'rgba(255, 255, 255,.1)',
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,

        color:
            theme.palette.mode === 'light' ? 'rgba(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
                backgroundColor: '#fff !important',
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));


const NavItem = ({ item, active }: any): any => {
    // obtener si ya completó registro
    const register_complete: boolean = useSelector(selectIsRegisterCompleted);

    const { t } = useTranslation();

    const { title, path, icon, info, children, isProduction, showInRegister } = item;

    let isActiveRoot = active(item.path);
    //console.log(`item ${title} is active? ${isActiveRoot}, path es: ${path}`);

    if (!isActiveRoot && children) {
        const find = children.find((c: any) => {
            return active(c.path)
        });

        isActiveRoot = active(find?.path || "");
    }

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    //console.log('children', children);

    const isProdEnv = process.env.NODE_ENV === 'production';
    const renderMenu = (isProdEnv) ? isProduction : true;

    if (!showInRegister && !register_complete) return null;

    return (
        <div style={{ textAlign: 'center', height: '100px' }} key={`menu-${item.title}`}>
            {/* standalone */}
            {
                (!children && renderMenu) && (
                    <Tooltip title={t(`menu.${title}`)}>
                        <Button
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            disableElevation
                            component={RouterLink}
                            to={path}
                        >
                            {
                                !isActiveRoot && <img src={`/static/images/sidebar-icons/${item.title}.svg`} height={70} width={70} />
                            }

                            {
                                isActiveRoot && <img src={`/static/images/sidebar-icons/${item.title}-activo.svg`} height={70} width={70} />
                            }
                        </Button>
                    </Tooltip>
                )
            }

            {/* with sub-menus */}
            {
                (children && renderMenu) && (
                    <>
                        <Tooltip title={t(`menu.${title}`)}>
                            <Button
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                disableElevation
                                onClick={handleClick}
                            >
                                {
                                    !isActiveRoot && <img src={`/static/images/sidebar-icons/${item.title}.svg`} height={70} width={70} />
                                }

                                {
                                    isActiveRoot && <img src={`/static/images/sidebar-icons/${item.title}-activo.svg`} height={70} width={70} />
                                }
                            </Button>
                        </Tooltip>

                        <StyledMenu
                            id="demo-customized-menu"
                            MenuListProps={{
                                'aria-labelledby': 'demo-customized-button',
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                        >
                            {
                                children.map((child: any, index: number) => {
                                    const { title, path } = child;
                                    //console.log('child', child);

                                    return (
                                        <div key={`${title}`}>
                                            <ListItemButton
                                                sx={{ pl: 2 }}
                                                disableRipple
                                                disableGutters
                                                component={RouterLink}
                                                to={path}
                                                onClick={handleClose}
                                            >
                                                <ListItemText primary={t(`menu.${title}`)} />
                                            </ListItemButton>

                                            {(index !== children.length - 1) && <Divider sx={{ my: 0.5 }} />}
                                        </div>
                                    );
                                })
                            }
                        </StyledMenu>
                    </>
                )
            }
        </div>
    );
}

type TItemNAv = {
    title: string,
    path?: string,
    icon: any,
    children?: Array<any>
}

type NavSectionProps = {
    navConfig: Array<TItemNAv>;
}

const NavSection = ({ navConfig, ...other }: NavSectionProps): any => {
    const { pathname } = useLocation();
    const match = (path: any) => (path ? !!matchPath(pathname, { path, exact: false }) : false);

    return (
        <Box {...other}>
            <List disablePadding>
                {
                    navConfig.map((item: any) => {
                        return <NavItem key={item.title} item={item} active={match} />
                    })
                }
            </List>
        </Box>
    );
}

export default NavSection
